import React from 'react'

// import { Container } from './styles'
import { ReactComponent as BurgerSvg } from '../../assets/svg/burger.svg'
import { ReactComponent as DashboardSvg } from '../../assets/svg/dashboard.svg'
import { ReactComponent as EditorSvg } from '../../assets/svg/editor.svg'
import { ReactComponent as TableSvg } from '../../assets/svg/table.svg'
import { ReactComponent as SettingsSvg } from '../../assets/svg/settings.svg'
import { ReactComponent as ArrowDownSvg } from '../../assets/svg/arrow-down.svg'
import { ReactComponent as ArrowRightSvg } from '../../assets/svg/arrow-right.svg'
import { ReactComponent as ArrowLeftSvg } from '../../assets/svg/arrow-left.svg'
import { ReactComponent as UploadSvg } from '../../assets/svg/upload.svg'
import { ReactComponent as CloseSvg } from '../../assets/svg/close.svg'
import { ReactComponent as PlusSvg } from '../../assets/svg/plus.svg'
import { ReactComponent as TrashSvg } from '../../assets/svg/trash.svg'
import { ReactComponent as QRCodeSvg } from '../../assets/svg/qrcode.svg'
import { ReactComponent as EditSvg } from '../../assets/svg/edit.svg'
import { ReactComponent as SearchSvg } from '../../assets/svg/search.svg'
import { ReactComponent as ArrowRightSecondSvg } from '../../assets/svg/arrow-right-second.svg'
import { ReactComponent as PrintSvg } from '../../assets/svg/print.svg'
import { ReactComponent as DownloadSvg } from '../../assets/svg/download.svg'
import { ReactComponent as UserSvg } from '../../assets/svg/user.svg'
import { ReactComponent as TimeAtackSvg } from '../../assets/svg/time-atack.svg'
import { ReactComponent as ClockSvg } from '../../assets/svg/clock.svg'
import { ReactComponent as DollarSignSvg } from '../../assets/svg/dollar-sign.svg'
import { ReactComponent as StarSvg } from '../../assets/svg/star.svg'
import { ReactComponent as FinanceSvg } from '../../assets/svg/finance.svg'
import { ReactComponent as FinanceFilledSvg } from '../../assets/svg/finance-filled.svg'
import { ReactComponent as TableFilledSvg } from '../../assets/svg/table-filled.svg'
import { ReactComponent as SongFilledSvg } from '../../assets/svg/song-filled.svg'
import { ReactComponent as UserFilledSvg } from '../../assets/svg/user-filled.svg'
import { ReactComponent as InfoSvg } from '../../assets/svg/info.svg'
import { ReactComponent as AdjustmentSvg } from '../../assets/svg/adjustment.svg'
import { ReactComponent as DownloadGreySvg } from '../../assets/svg/download_grey.svg'

type IProps = any & {
  name: string;
}

const Icon = ({ name, ...rest }: IProps) => {
  switch (name) {
    case 'burger': return <BurgerSvg {...rest} />
    case 'dashboard': return <DashboardSvg {...rest} />
    case 'editor': return <EditorSvg {...rest} />
    case 'table': return <TableSvg {...rest} />
    case 'settings': return <SettingsSvg {...rest} />
    case 'arrow-down': return <ArrowDownSvg {...rest} />
    case 'arrow-left': return <ArrowLeftSvg {...rest} />
    case 'arrow-right': return <ArrowRightSvg {...rest} />
    case 'upload': return <UploadSvg {...rest} />
    case 'close': return <CloseSvg {...rest} />
    case 'plus': return <PlusSvg {...rest} />
    case 'trash': return <TrashSvg {...rest} />
    case 'qrcode': return <QRCodeSvg {...rest} />
    case 'edit': return <EditSvg {...rest} />
    case 'arrow-right-second': return <ArrowRightSecondSvg {...rest} />
    case 'search': return <SearchSvg {...rest} />
    case 'print': return <PrintSvg {...rest} />
    case 'download': return <DownloadSvg {...rest} />
    case 'user': return <UserSvg {...rest} />
    case 'time-atack': return <TimeAtackSvg {...rest} />
    case 'clock': return <ClockSvg {...rest} />
    case 'dollar-sign': return <DollarSignSvg {...rest} />
    case 'star': return <StarSvg {...rest} />
    case 'finance': return <FinanceSvg {...rest} />
    case 'finance-filled': return <FinanceFilledSvg {...rest} />
    case 'table-filled': return <TableFilledSvg {...rest} />
    case 'song-filled': return <SongFilledSvg {...rest} />
    case 'user-filled': return <UserFilledSvg {...rest} />
    case 'info': return <InfoSvg {...rest} />
    case 'adjustment': return <AdjustmentSvg {...rest} />
    case 'download_grey': return <DownloadGreySvg {...rest} />
    default: return null
  }
}

export default Icon
